import React, { useCallback, memo } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { openGroupsTray, setOverlapHoverGroup } from '@actions/map-actions';
import GroupListItem from '@shared/new-list-item/group-list-item';

const Group = ({ id, position, ...otherProps }) => {
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    const trayProps = {
      id,
      item: { id, position, ...otherProps },
      position
    };
    dispatch(openGroupsTray(trayProps));
  }, [dispatch, id, position, otherProps]);

  const handleMouseEnter = useCallback(() => {
    const group = { id, ...otherProps };
    dispatch(setOverlapHoverGroup(group));
  }, [dispatch, id, otherProps]);

  const handleMouseLeave = useCallback(() => {
    dispatch(setOverlapHoverGroup());
  }, [dispatch]);

  return (
    <GroupListItem
      {...otherProps}
      id={id}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    />
  );
};

Group.propTypes = {
  id: PropTypes.number,
  position: PropTypes.object
};

export default memo(Group);
